<template>
    <v-container class="pricing px-0">
        <h1 class="smfm-page-title mx-5"
            :class="[
                $vuetify.breakpoint.smAndDown ? 'text-left' : 'text-center', 
                currentCurrCode !== 'EUR' ? 'mb-21' : ''
            ]">
            {{ $t('app.pricing.pricing') }}
            <about-pricing-dropdown></about-pricing-dropdown>
        </h1>
        <about-pricing-plans :plans="plans" :features="features"></about-pricing-plans>
    </v-container>
</template>

<script>
    // Taken from #2 on https://speckyboy.com/css-responsive-pricing-table/ - https://codepen.io/Creaticode/pen/pHEyJ
    import { mapGetters } from "vuex";
    import titleMixin from "@/mixins/titleMixin";
    import AboutPricingDropdown from "@/components/about/AboutPricingDropdown";
    import AboutPricingPlans from "@/components/about/AboutPricingPlans";
    const UNLIMITED = 'unlimited';

    export default {
        name: "AboutPricing",
        components: { AboutPricingPlans, AboutPricingDropdown },
        mixins: [ titleMixin ],
        data() {
            return {
                features: [
                    {code: 'demo', label: this.$t('app.pricing.featuredemo')},
                    {code: 'systemlogos', label: this.$t('app.pricing.featurelogos')},
                    {code: 'systemtemplates', label: this.$t('app.pricing.featuretemplates')},
                    {code: 'library', label: this.$t('app.pricing.featurelibrary')},
                    //{code: 'savestatic', label: ' saved static codes'},
                    {code: 'dynamic', label: this.$t('app.pricing.dynamiccodes')},
                    {code: 'uploads', label: this.$t('app.pricing.uploadedfiles')},
                    {code: 'apis', label: this.$t('app.pricing.apicalls'), showunlimited: true},
                    //{code: 'usebulk', label: 'Coming soon: Generate QR codes <strong>in bulk</strong>'},
                    {code: 'users', label: this.$t('app.pricing.additionalusers'), label1: this.$t('app.pricing.additionaluser')},
                ],
            }
        },
        computed: {
            ...mapGetters("currency", ["currencies", "currentCurrCode"]),
            plans() {
                return [{name: this.$t('plan.free'), price: 0, shortname: 'free',
                         features: {demo: UNLIMITED, systemlogos: UNLIMITED, systemtemplates: UNLIMITED}},
                        ...this.pricePlans.map(plan => {
                            return {name: this.$t('plan.'+plan.shortname), price: plan.price, featured: plan.featured, shortname: plan.shortname,
                                    features: {demo: false, systemlogos: false, systemtemplates: false, library: UNLIMITED, ...plan.features}}
                        })]
            }
        },
        created() {
            this.setTitle(this.$t('app.pricing.metatitle'))
            this.setMetaDesc(this.$t('app.pricing.metadesc'))
        },
    }
</script>

<style scoped>
.mb-21 {
    margin-bottom: 84px;
}
</style>